import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const PORTAL_API = `${BACKEND_URL}/api`;
export const PORTAL_TOKEN_KEY = "taxflow_portal_token";
// Governed Portal View (admin acting on behalf) — stored SEPARATELY from a real
// client login so the two identities never bleed into each other.
export const PORTAL_VIEW_KEY = "taxflow_portalview";

// Dedicated client-portal axios instance (separate `portal` JWT from staff auth).
export const portalApi = axios.create({ baseURL: PORTAL_API, withCredentials: false });

export const getPortalView = () => {
  try { return JSON.parse(localStorage.getItem(PORTAL_VIEW_KEY) || "null"); }
  catch { return null; }
};
export const setPortalView = (v) =>
  v ? localStorage.setItem(PORTAL_VIEW_KEY, JSON.stringify(v)) : localStorage.removeItem(PORTAL_VIEW_KEY);
export const isPortalViewMode = () => !!getPortalView();

const WRITE_METHODS = new Set(["post", "put", "patch", "delete"]);

portalApi.interceptors.request.use((config) => {
  const view = getPortalView();
  const clientTok = localStorage.getItem(PORTAL_TOKEN_KEY);
  // Portal View token takes precedence — an admin viewing a portal is NEVER a real client login.
  const t = view?.token || clientTok;
  if (t) config.headers.Authorization = `Bearer ${t}`;
  // Interactive governed on-behalf: auto-attach the session reason to writes unless a
  // caller has already supplied an explicit (action-specific) reason header.
  if (view && view.mode === "interactive" && WRITE_METHODS.has((config.method || "").toLowerCase())) {
    if (!config.headers["X-Portal-View-Reason"] && view.reason) {
      config.headers["X-Portal-View-Confirm"] = "true";
      config.headers["X-Portal-View-Reason"] = view.reason;
    }
  }
  return config;
});

export const setPortalToken = (t) => {
  t ? localStorage.setItem(PORTAL_TOKEN_KEY, t) : localStorage.removeItem(PORTAL_TOKEN_KEY);
  // Defense-in-depth: when a real portal session starts, the staff token is no longer relevant
  // in this browser context. Clearing it prevents a stale staff token from granting access
  // to staff routes if a portal URL accidentally falls through the route guard.
  if (t) localStorage.removeItem("taxflow_token");
};
export const getPortalToken = () => localStorage.getItem(PORTAL_TOKEN_KEY);
